import React, { FC } from 'react';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';
import { useTranslation } from '../../../../translations';
import { Fetcher, useBoolState, useFetcher } from '../../../../utils';
import { KeyView } from './KeyView';
import { WebhookModal } from './WebhookModal';
import { WebhookTable } from './WebhookTable';

export const WebhookPage: FC = () => {
  const { ts } = useTranslation();
  const [modalOpen, enableModal, disableModal] = useBoolState(false);
  const req = useFetcher(async () => {
    const [types, webhooks, publicKey] = await Promise.all([
      api.getWebhookTypes(),
      api.getWebhooks(),
      api.getWebhookKey(),
    ]);

    return { types, webhooks, publicKey };
  });

  if (!req.success) {
    return <Fetcher result={req} />;
  }

  const { types, webhooks, publicKey } = req.data;

  return (
    <div>
      <KeyView value={publicKey} />
      <br />
      <WebhookTable onChange={req.refresh} webhooks={webhooks} />
      <Button color="primary" id="webhook-create" onClick={enableModal}>
        {ts('common.create_new')}
      </Button>
      <WebhookModal
        onClose={(cancelled) => {
          disableModal();
          if (cancelled) {
            return;
          }

          toast.success(ts('webhook_created'));
          req.refresh();
        }}
        open={modalOpen}
        types={types}
      />
    </div>
  );
};
